/* eslint-disable react/jsx-no-target-blank */
import { useState } from "react";

const STORYLO_URL = "https://open.spotify.com/show/033xKhgIPt6oQg3YcdCAQa?si=cA7HdreDTYOACAFY-9DDGA";
const LOGO = "/storylo-logo.png";

export function StoryloFab() {
  const [closed, setClosed] = useState(false);
  if (closed) return null;
  return (
    <div className="storylo-fab" data-testid="storylo-fab">
      <a
        href={STORYLO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="storylo-fab-link"
        data-testid="storylo-fab-link"
        aria-label="Listen to Storylo on Spotify"
      >
        <span className="storylo-fab-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="#1db954">
            <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm5.5 17.3a.75.75 0 0 1-1 .25c-2.8-1.7-6.3-2.1-10.4-1.1a.75.75 0 1 1-.3-1.5c4.5-1 8.3-.6 11.4 1.3a.75.75 0 0 1 .3 1Zm1.5-3.3a.94.94 0 0 1-1.3.3c-3.2-2-8.1-2.6-11.9-1.4a.94.94 0 1 1-.6-1.8c4.3-1.3 9.7-.7 13.4 1.6a.94.94 0 0 1 .4 1.3Zm.15-3.4C15.3 8.4 8.9 8.1 5.4 9.2a1.13 1.13 0 0 1-.7-2.2c4-1.2 11.1-.9 15.4 1.7a1.13 1.13 0 0 1-1.15 1.9Z"/>
          </svg>
        </span>
        <span className="storylo-fab-text">
          <span className="storylo-fab-label">Listen on</span>
          <span className="storylo-fab-brand">Storylo</span>
        </span>
      </a>
      <button
        type="button"
        className="storylo-fab-close"
        onClick={() => setClosed(true)}
        aria-label="Hide"
        data-testid="storylo-fab-close"
      >×</button>
    </div>
  );
}

export function StoryloCard() {
  return (
    <a
      className="storylo-card"
      href={STORYLO_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="storylo-card"
    >
      <img src={LOGO} alt="Storylo on Spotify" className="storylo-card-art" />
      <div className="storylo-card-body">
        <div className="storylo-card-kicker">Discover Storylo</div>
        <div className="storylo-card-title">Real stories. Real lives. Real change.</div>
        <div className="storylo-card-desc">
          From animal rescues and world disasters to activists rewriting
          history — Storylo brings powerful real-life stories to light, with
          links to support the causes that need it.
        </div>
        <span className="storylo-card-cta">
          Open Storylo
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M14 3v2h3.59L7.05 15.54l1.41 1.41L19 6.41V10h2V3h-7z"/>
          </svg>
        </span>
      </div>
    </a>
  );
}
